import type FlightSchoolCourse from '@/types/FlightSchoolCourse';
import type { useUserStore } from '@/stores/user';

export enum FlightSchoolRole {
    GLOBAL = 'ROLE_GLOBAL_ADMIN',
    OWNER = 'ROLE_SCHOOL_OWNER',
    ADMIN = 'ROLE_COURSE_ADMIN',
}

export type SchoolRoles = {
    role: string;
    schools: number[];
};

export type SchoolCourses = {
    school: number;
    courses: FlightSchoolCourse['certificate']['uuid'][];
};

export interface FlightSchoolUser {
    id: number;
    roles: FlightSchoolRole[];
    schoolRoles: SchoolRoles[];
    schoolCourses: SchoolCourses[];
    accessDate: number;
}

export const mapRoles = (roles: string[]): FlightSchoolRole[] => (
    roles.map((role) => role as FlightSchoolRole)
);

export const mapSchoolRoles = (schoolRoles: Record<string, number[]>): SchoolRoles[] => (
    Object.entries(schoolRoles).map(([role, schools]) => ({ role, schools }))
);

export const mapSchoolCourses = (schoolCourses: Record<string, string[]>): SchoolCourses[] => (
    Object.entries(schoolCourses).map(([school, courses]) => (
        { school: parseInt(school, 10), courses }
    ))
);

export const getUserRoleForSchool = (userStore: ReturnType<typeof useUserStore>, schoolId: number): string => {
    if (userStore.isGlobalAdmin) {
        return 'Global Admin';
    }
    if (userStore.isSchoolOwnerForSchool(schoolId)) {
        return 'Primary Admin';
    }
    return 'Course Admin';
};
